'use strict';

var DeviceSelectView = require('components/devices/views/common/device_select_view');
var OOP = require('utils/oop');

var StatsDeviceSelectView = OOP.extend(
    DeviceSelectView,
    {
        onBeforeRender: function () {
            this.selectionCtx.selectModels(this.collection.models);
        },

        initialize: function (options) {
            this.selectionCtx = options.selectionCtx;
            this.base.initialize(options);
        },

        rowSelected: function (e) {
            var self = this;
            this.base.rowSelected(e);
            this.selectionCtx.update(this.collection.models);
            setTimeout(function () {
                self.updateTableTitle();
            });
        },

        getSelectionButtons: function () {
            return [];
        },
    },
    'StatsDeviceSelectView'
);

module.exports = StatsDeviceSelectView;
